import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page from "components/UI/Page";
import { Card } from "@mui/material";
import { useLocation } from "react-router-dom";
import { fetchDataAction } from "store/features/coreSlice";
import DataTable from "components/UI/Table/DataTable";
import PagesCount from "helpers/pages-count";
import dataVal from "./dataVal.json";

const Support = () => {
  const baseUrl = `items/technical_support?fields=id,title,email,full_name,message`;
  const dispatch = useDispatch();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.auth);
  const { technicalSupportsMeta, technicalSupports, limit } = useSelector((state) => state.core);
  const [newArr, setNewArr] = useState([]);
  const [number, setNumber] = useState(1);
  const [route, setRoute] = useState(null);
  const [pageOptions, setPageOption] = useState([]);

  const prepareTableRows = () => {
    let item = {};
    const Arr = [];
    let keys = [];
    const d = [];
    for (let i = 0; i < PagesCount(+technicalSupportsMeta.filter_count, limit); i += 1) {
      d.push(i);
    }
    setPageOption(d);
    if (technicalSupports && technicalSupports.length !== 0) {
      technicalSupports.forEach((technicalSupport) => {
        item = {};
        keys = Object.keys(technicalSupport);
        keys.forEach((element) => {
          item[element] = technicalSupport[element];
        });

        Arr.push(item);
      });
      setNewArr(Arr);
    } else {
      setNewArr([]);
    }
  };

  const setPageNumber = (num) => {
    if (num) {
      setNumber(num);
      dispatch(
        fetchDataAction({
          url: `${baseUrl}&meta=*&limit=${limit}&page=${num}`,
          varName: "technicalSupports",
        })
      );
    }
  };

  const setSortByHandeller = (val) => {
    let urlVal = `${baseUrl}&meta=*&limit=${limit}&page=${number}`;

    urlVal += `&sort=${val.desc ? "-" : ""}${val.id}`;
    dispatch(
      fetchDataAction({
        url: urlVal,
        varName: "technicalSupports",
      })
    );
  };

  useEffect(() => {
    dispatch(
      fetchDataAction({
        url: `${baseUrl}&meta=*&limit=${limit}&page=${number}`,
        varName: "technicalSupports",
      })
    );
  }, [limit]);

  useEffect(() => {
    const routeItem = userInfo.routes.filter(
      (x) =>
        `${x.route_name}` === location.pathname.split("/")[location.pathname.split("/").length - 1]
    )[0];
    setRoute(routeItem);
  }, []);

  useEffect(() => {
    if (technicalSupports && route) {
      prepareTableRows();
    }
  }, [technicalSupports, route]);

  if (newArr === []) {
    return null;
  }

  return (
    <Page>
      <Card style={{ padding: 20, position: "relative" }}>
        {/* <DataModal
          handleClose={() => {
            setOpen(false);
          }}
          open={open}
        >
          {formContainer}
        </DataModal> */}
        {/* <DeleteModal
          handleClose={handleDeleteModalClose}
          handleConfirmDelete={handleConfirmDelete}
          openDeleteModal={openDeleteModal}
        /> */}
        {/* <FilterForm pageNum={number} baseUrl={baseUrl} setUrl={setUrl} setNumber={setNumber} /> */}

        {/* {simbleLayout && route?.create && (
          <MDButton
            variant="gradient"
            color="info"
            onClick={handleOpen}
            style={{ float: "left" }}
            size="large"
          >
            <Icon>add</Icon>&nbsp; {t("add")}
          </MDButton>
        )} */}
        <DataTable
          table={{ columns: dataVal.columns, rows: newArr }}
          item={false}
          pageOptions={pageOptions}
          isSorted
          isPagination
          entriesPerPage
          showTotalEntries
          noEndBorder
          search
          setPageNum={setPageNumber}
          setSortByHandeller={setSortByHandeller}
          pageIndex={number - 1}
          allRowsCount={technicalSupportsMeta ? +technicalSupportsMeta.filter_count : 0}
        />
        {/* <input type="file" name="upload" id="upload" onChange={readUploadFile} /> */}
      </Card>
    </Page>
  );
};

export default Support;
